/**
 * @fileOverview Cricket data parsers.
 * Aggregates and exports cricket specific data parsers
 */

import scoreboard   from './scoreboard/index'
import gamePackage  from './gamepackage/index'

export { scoreboard }
export { gamePackage }

export default {
  scoreboard,
  gamePackage
}



// WEBPACK FOOTER //
// ../app/lib/transform/parsers/cricket/index.js